declare var grecaptcha: any;

$("#returnform").one("submit", function (e) { 
    e.preventDefault();
    
    var form = $(this)[0] as HTMLFormElement;
    $("#btnsubmit").attr("disabled", "disabled");

    var apiKey = $(this).attr('data-gapikey');

    grecaptcha.ready(function() {
        grecaptcha.execute(apiKey, { action: 'contact' }).then(function(token) {
            $('#RecaptchaToken').val(token);
            form.submit();
        });
    });
})